<template>
  <client-only>
    <v-card class="employee-card px-7 sm-px-2" flat>
      <v-row align="center">
        <v-col lg="4" class="employ-details">
          <v-row align="center">
            <v-col lg="2" cols="12" class="employ-avatar">
              <v-avatar size="50" class="profile my-3">
                <img :src="`${employeeImageLink}`" :alt="by" @error="imageLoadError" v-if="imageIsValid" />
              </v-avatar>
            </v-col>
            <v-col lg="10" class="employ-name">
              <h3>{{by}}</h3>
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="8" sm="12" cols="12">
          <v-row>
            <v-col class="quotes" lg="1"> 
              <span>"</span>
            </v-col>
            <v-col lg="11">
              <p class="caption px-2" v-html="testimonial"></p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </client-only>
</template>

<script>

export default {
  props: {
    by: {
      type: String
    },
    employeeImageLink: {
      type: String
    },
    testimonial: {
      type: String
    },
    testimonialId: {
      type: Number
    }
  },

  data() {
    return {
      imageIsValid: true,
      employeeRole: '',
      employeeName: '',
      citation: ''
    }
  },
  methods: {
    imageLoadError() {
      this.imageIsValid = false
    }
  }
}
</script>


<style lang="scss" scoped>
.employee-card {
  .employ-details {
    .employ-avatar, .employ-name {
      padding: 0;
    }
  }
  h3 {
    font-size: 24px;
  }
  .quotes {
    font-size: 100px;
    color: #ff7100;
    padding: 0;
    margin: -15px 15px 0 -10px;
    flex: 0.1;
    height: 0;
  }
  .caption {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 600px) {
  .employ-details, .caption {
    text-align: center;
  }
  .quotes {
    display: none;
  }
  .v-avatar {
    width: auto !important;
    height: auto !important;
  }
}
</style>
